import { Link } from "react-router-dom";
import { homePage } from "@/mocks/home";
import ScrollReveal from "@/components/feature/ScrollReveal";

export default function HomeDelivery() {
  const { delivery } = homePage;
  return (
    <ScrollReveal delay={100}>
      <section className="py-16 md:py-20 bg-redbean-lightcream">
        <div className="mx-auto px-4 md:px-6 lg:px-8" style={{ maxWidth: "1200px" }}>
          <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
            {/* Left: Image */}
            <div className="flex-1 w-full max-w-md lg:max-w-none">
              <div className="rounded-card overflow-hidden shadow-card" style={{ height: "360px" }}>
                <img
                  src="https://readdy.ai/api/search-image?query=elegant%20gift%20box%20packaging%20with%20taiyaki%20red%20bean%20cakes%20inside%20Japanese%20minimalist%20packaging%20design%20with%20gold%20ribbon%20and%20warm%20red%20brown%20accents%20premium%20food%20gift%20set%20warm%20cream%20and%20red%20color%20scheme%20product%20photography%20on%20light%20cream%20background%20appetizing%20presentation&width=800&height=600&seq=home-del-1&orientation=landscape"
                  alt="冷凍宅配紅豆餅禮盒包裝"
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                  decoding="async"
                />
              </div>
            </div>

            {/* Right: Text */}
            <div className="flex-1 text-center lg:text-left">
              <h2
                className="font-heading font-bold text-redbean-coffee mb-5 text-balance"
                style={{ fontSize: "clamp(1.5rem, 3vw, 2.125rem)", lineHeight: 1.4 }}
              >
                {delivery.title}
              </h2>
              <p
                className="text-redbean-coffee/65 mb-8 max-w-md mx-auto lg:mx-0"
                style={{ fontSize: "1.1875rem", lineHeight: 1.75 }}
              >
                {delivery.desc}
              </p>
              <div className="flex flex-col sm:flex-row gap-3 justify-center lg:justify-start">
                <Link
                  to="/gift-box"
                  className="inline-flex items-center justify-center gap-2 px-7 py-3.5 bg-redbean-primary text-redbean-cream font-semibold rounded-full hover:bg-redbean-coffee transition-colors whitespace-nowrap text-[1.0625rem]"
                >
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-truck-line" />
                  </span>
                  {delivery.ctaPrimary}
                </Link>
                <Link
                  to="/gift-box"
                  className="inline-flex items-center justify-center gap-2 px-7 py-3.5 border-2 border-redbean-primary text-redbean-primary font-semibold rounded-full hover:bg-redbean-primary hover:text-redbean-cream transition-colors whitespace-nowrap text-[1.0625rem]"
                >
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-gift-2-line" />
                  </span>
                  {delivery.ctaSecondary}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </ScrollReveal>
  );
}